import Mesh from '../Mesh';
import TransformData from '../TransformData';
import RenderData from '../RenderData';
import MeshData from '../MeshData';

class MeshStatic extends Mesh {

  constructor() {
    super();

    this._id = Mesh.ID++; // useful id to retrieve a mesh (dynamic mesh, multires mesh, voxel mesh)

    this._renderData = new RenderData();
    this._meshData = new MeshData();
    this._transformData = new TransformData();
  }
}

export default MeshStatic;
